const trans = {
  state: {
    transitions: null,
    transitionStatusCurrent: null,
    transitionStatusPrevious: null
  },
  mutations: {
    changeTransitions(state, payload) {
      state.transitions = payload;
    },
    changeTransitionStatusCurrent(state, payload) {
      state.transitionStatusCurrent = payload;
    },
    changeTransitionStatusPrevious(state, payload) {
      state.transitionStatusPrevious = payload;
    }
  },
  actions: {
    changeTransitions({ commit }, payload) {
      commit("changeTransitions", payload);
    },
    changeTransitionStatusCurrent({ commit }, payload) {
      commit("changeTransitionStatusCurrent", payload);
    },
    changeTransitionStatusPrevious({ commit }, payload) {
      commit("changeTransitionStatusPrevious", payload);
    }
  },
  getters: {
    getTransitions: state => {
      return state.transitions;
    },
    getTransitionStatusCurrent: state => {
      return state.transitionStatusCurrent;
    },
    getTransitionStatusPrevious: state => {
      return state.transitionStatusPrevious;
    }
  }
  // eslint-disable-next-line
}
// eslint-disable-next-line
export default trans;
